(() => {
  const initializeLoginModal = () => {
    const modal = document.querySelector('[data-cm-login-modal]');

    if (!modal) return;

    // Keep the fixed overlay out of the sticky Header stacking context.
    if (modal.parentElement !== document.body) document.body.append(modal);

    const panel = modal.querySelector('.cm-login-panel');
    const triggers = document.querySelectorAll('[data-cm-login-trigger]');
    const dismissSelector = '[data-cm-login-dismiss]';
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const closeDuration = reducedMotion ? 0 : 400;
    let closeTimer;
    let lastFocusedElement;
    let scrollLockState;

    const getFocusableElements = () =>
      [...panel.querySelectorAll(focusableSelector)].filter((element) => !element.hidden && element.offsetParent !== null);

    const lockScroll = () => {
      if (scrollLockState) return;

      const body = document.body;
      const root = document.documentElement;
      const scrollY = window.scrollY;
      const scrollbarWidth = window.innerWidth - root.clientWidth;
      const hasStableGutter = (getComputedStyle(root).scrollbarGutter || '').includes('stable');
      const computedPaddingRight = Number.parseFloat(window.getComputedStyle(body).paddingRight) || 0;

      scrollLockState = {
        scrollY,
        position: body.style.position,
        top: body.style.top,
        width: body.style.width,
        paddingRight: body.style.paddingRight,
      };

      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.width = '100%';

      if (scrollbarWidth > 0 && !hasStableGutter) body.style.paddingRight = `${computedPaddingRight + scrollbarWidth}px`;
    };

    const releaseScrollLock = () => {
      if (!scrollLockState) return;

      const body = document.body;
      const { scrollY, position, top, width, paddingRight } = scrollLockState;

      body.style.position = position;
      body.style.top = top;
      body.style.width = width;
      body.style.paddingRight = paddingRight;
      document.documentElement.classList.remove('cm-login-scroll-locked');
      document.body.classList.remove('cm-login-scroll-locked');
      scrollLockState = null;
      window.scrollTo(0, scrollY);
    };

    const restoreFocus = () => {
      if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus({ preventScroll: true });
    };

    const openModal = (event) => {
      event.preventDefault();
      window.clearTimeout(closeTimer);
      lastFocusedElement = document.activeElement;
      modal.hidden = false;
      modal.classList.remove('cm-login-is-closing');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();
      document.documentElement.classList.add('cm-login-scroll-locked');
      document.body.classList.add('cm-login-scroll-locked');

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          modal.classList.add('cm-login-is-open');
          const [firstFocusableElement] = getFocusableElements();
          (firstFocusableElement || panel).focus({ preventScroll: true });
        });
      });
    };

    const closeModal = () => {
      if (modal.hidden || modal.classList.contains('cm-login-is-closing')) return;

      modal.classList.remove('cm-login-is-open');
      modal.classList.add('cm-login-is-closing');
      modal.setAttribute('aria-hidden', 'true');
      restoreFocus();

      closeTimer = window.setTimeout(() => {
        modal.hidden = true;
        modal.classList.remove('cm-login-is-closing');
        releaseScrollLock();
      }, closeDuration);
    };

    triggers.forEach((trigger) => trigger.addEventListener('click', openModal));

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const dismissTarget = target ? target.closest(dismissSelector) : null;

      if (dismissTarget && modal.contains(dismissTarget)) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (modal.hidden || modal.classList.contains('cm-login-is-closing')) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = getFocusableElements();
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];

      if (!firstFocusableElement) {
        event.preventDefault();
        panel.focus({ preventScroll: true });
      } else if (event.shiftKey && document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus({ preventScroll: true });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLoginModal, { once: true });
  } else {
    initializeLoginModal();
  }
})();
